<template>
  <div class="newsDetail">
    <div class="title">{{ articleInfo.title }}</div>
    <div class="list acea-row row-middle">
      <div class="label cart-color line1">{{ articleInfo.cart_name }}</div>
      <div class="item">
        <span class="iconfont icon-shenhezhong"></span
        >{{ articleInfo.add_time }}
      </div>
      <div class="item">
        <span class="iconfont icon-liulan"></span>{{ articleInfo.visit }}
      </div>
    </div>

    <div class="carousel" v-if="articleInfo.video == '' ? false : true">
      <video :src="articleInfo.video" id="slideVideo" width="100%" height="100%;"  webkit-playsinline="" playsinline=""    type="video/mp4" preload="" x-webkit-airplay="true"   x5-playsinline="" :poster="img0" >
        </video>
      <div class="video_btn">
       <img src="@assets/images/playerBtn.png" />
       </div>
      </div>

    <div class="conter" v-html="articleInfo.content"></div>
    <div class="picTxt acea-row row-between-wrapper" v-if="storeInfo.id">
      <div class="pictrue"><img :src="storeInfo.image" /></div>
      <div class="text">
        <div class="name line1">{{ storeInfo.store_name }}</div>
        <div class="money font-color-red">
          ￥<span class="num">{{ storeInfo.ot_price }}</span>
        </div>
        <div class="y_money">￥{{ storeInfo.price }}</div>
      </div>
      <router-link :to="{ path: '/detail/' + storeInfo.id }">
        <div class="label"><span class="span">查看商品</span></div>
      </router-link>
    </div>
    <div class="bnt bg-color-red" v-if="isWeixin" @click="setShareInfoStatus">
      和好友一起分享
    </div>
    <ShareInfo
      v-on:setShareInfoStatus="setShareInfoStatus"
      :shareInfoStatus="shareInfoStatus"
    ></ShareInfo>
  </div>
</template>
<style scoped>
.newsDetail .picTxt {
  width: 6.9rem;
  height: 2rem !important;
  border-radius: 0.2rem;
  border: 1px solid #e1e1e1;
  position: relative;
  margin: 0.3rem auto 0 auto;
}
.newsDetail .picTxt .pictrue {
  width: 2rem;
  height: 2rem;
}
.newsDetail .picTxt .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 0.2rem 0 0 0.2rem;
  display: block;
}
.newsDetail .picTxt .text {
  width: 4.6rem;
}
.newsDetail .picTxt .text .name {
  font-size: 0.3rem;
  color: #282828;
}
.newsDetail .picTxt .text .money {
  font-size: 0.24rem;
  margin-top: 0.4rem;
  font-weight: bold;
}
.newsDetail .picTxt .text .money .num {
  font-size: 0.36rem;
}
.newsDetail .picTxt .text .y_money {
  font-size: 0.26rem;
  color: #999;
  text-decoration: line-through;
}
.newsDetail .picTxt .label {
  position: absolute;
  background-color: #303131;
  width: 1.6rem;
  height: 0.5rem;
  right: -0.07rem;
  border-radius: 0.25rem 0 0.06rem 0.25rem;
  text-align: center;
  line-height: 0.5rem;
  bottom: 0.24rem;
}
.newsDetail .picTxt .label .span {
  background-image: linear-gradient(to right, #fff71e 0%, #f9b513 100%);
  background-image: -webkit-linear-gradient(to right, #fff71e 0%, #f9b513 100%);
  background-image: -moz-linear-gradient(to right, #fff71e 0%, #f9b513 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.newsDetail .picTxt .label:after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  border-bottom: 0.08rem solid #303131;
  border-right: 0.08rem solid transparent;
  top: -0.08rem;
  right: 0;
}
.newsDetail .bnt {
  color: #fff;
  font-size: 0.3rem;
  width: 6.9rem;
  height: 0.9rem;
  border-radius: 0.45rem;
  margin: 0.48rem auto 0 auto;
  text-align: center;
  line-height: 0.9rem;
}
.vjs-big-play-button{
	left:50% !important;
	top: 50% !important;
	margin-top: -1em ;
	margin-left: -1.5em ;
}
.video-js .vjs-big-play-button {
  border:unset!important;
  background-color:unset!important;
}
.video-js .vjs-big-play-button .vjs-icon-placeholder:before {
  font-size: 45px;
}
.vjs-poster {
  background-size: 100% 100%!important;
}
</style>
<script>
import 'video.js/dist/video-js.css';
import videojs from 'video.js';
import "@assets/css/style1.css";
import "@assets/js/jquery.min.js";
import { getArticleDetails } from "@api/public";
import ShareInfo from "@components/ShareInfo";
import { isWeixin } from "@utils/index";
import { openShareAll } from "@libs/wechat";

export default {
  name: "NewsDetail",
  components: { ShareInfo },
  props: {},
  data: function() {
    return {
      myPlayer: '', // 视频播放器实例
      articleInfo: {},
      storeInfo: {},
      shareInfoStatus: false,
      isWeixin: isWeixin()
    };
  },
  watch: {
    $route(to) {
      if (to.name === "NewsDetail") this.articleDetails();
    }
  },
  mounted: function() {
    this.articleDetails();
  },
    mounted: function() {
      this.articleDetails();
      // (function(doc, win) {
      //     var docEl = doc.documentElement,
      //         resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
      //         recalc = function() {
      //             var clientWidth = docEl.clientWidth;
      //             if(!clientWidth) return;
      //             docEl.style.fontSize = 100 * (clientWidth / 375) + 'px';
      //         };
      //     if(!doc.addEventListener) return;
      //     win.addEventListener(resizeEvt, recalc, false);
      //     doc.addEventListener('DOMContentLoaded', recalc, false);
      // })(document, window);
      console.log("-------1-------")
      function load(){
          $(".video_btn").hide();
          $("#slideVideo").trigger('play');

      }

      $(".video_btn").on("click", function() {
          $("#slideVideo").trigger('play');
          $(".video_btn").hide();
          return false;
      })
      $(".swiper-slideVideo").on("click", function() {
          $("#slideVideo").trigger('pause');
          $(".video_btn").show();
      })
      $("#slideVideo").on("ended", function() {
          $(".video_btn").show();
      })
      $(".vAndi").show();
      $(".videoBtn").on("click", function() {
          $(".videoBtn").addClass("SWactive");
          $(".imgBtn").removeClass("SWactive");
          swiper1.slideTo(0, 1000, false);
          $(".weizhi").hide();
          return false;
      })
      $(".imgBtn").on("click", function() {
          $(".imgBtn").addClass("SWactive");
          $(".videoBtn").removeClass("SWactive");
          swiper1.slideTo(1, 1000, false);
          $("#slideVideo").trigger('pause');
          $(".video_btn").show();
          $(".weizhi").show();
          return false;
      })
  },
  methods: {
    updateTitle() {
      document.title = this.articleInfo.title || this.$route.meta.title;
    },
    articleDetails: function() {
      let that = this,
        id = this.$route.params.id;
      getArticleDetails(id).then(res => {
        that.articleInfo = res.data;
        that.storeInfo = res.data.store_info || {};
        that.updateTitle();
        if (that.isWeixin) that.share();
      });
    },
    setShareInfoStatus: function() {
      this.shareInfoStatus = !this.shareInfoStatus;
    },
    share: function() {
      openShareAll({
        desc: this.articleInfo.synopsis,
        title: this.articleInfo.title,
        link: location.href,
        imgUrl: this.articleInfo.image_input.length
          ? this.articleInfo.image_input[0]
          : ""
      });
    }
  }
  
  
};
</script>
<style scoped>
.carousel{
  margin:.13rem auto;
  width:90%;
  }
</style>
